var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor",on:{"click":function($event){return _vm.handleClick($event)}}},[_c('editor-content',{staticClass:"editor__reader",attrs:{"editor":_vm.editor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }